import {useCallback, useContext, useEffect, useState} from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { DrawerContext } from 'src/contexts/DrawerContext';
import Logo from 'src/components/Logo';

import {Box, Drawer, Hidden, IconButton, Typography} from '@material-ui/core';

import { experimentalStyled } from '@material-ui/core/styles';
import DrawerMenu from './DrawerMenu';
import DrawerUserBox from "./DrawerMenu/UserBox";
import {ReactComponent as CloseIcon} from "../../../assets/icons/close.svg";
import menuItems, {MenuItems} from "./DrawerMenu/items";
import {sendGetRequest} from "../../../utils/axios";
import useAuth from "../../../hooks/useAuth";
import {ReactComponent as LogoImg} from "../../../assets/images/logo_payoff.svg";
import {Booking} from "../../../models/booking";
import {isSameDay, startOfDay} from "date-fns";
import BookingStatus from "../../../enums/BookingStatus";

const DrawerWrapper = experimentalStyled(Drawer)(
    ({theme}) => `
    z-index: 100000000010;
        div.MuiDrawer-paper {
        width: 100%;
        }
        
        @media (max-width: 1024px) {
            & .MuiDrawer-paper {
                 max-width: 400px;
            }
        }
        `
);

const DrawerContainerWrapper = experimentalStyled(Box)(
  ({ theme }) => `
          color: ${theme.drawer.textColor};
        background: rgba(180, 190, 234, 0.16);
        height: 100%;
        
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            position: fixed;
            width: 280px;
            z-index: 10001;
            border-radius: 0;
            box-shadow: 2px 0px 6px 0 rgb(0 0 0 / 15%);
        }
`
);

const TopSection = experimentalStyled(Box)(
  ({ theme }) => `
        display: flex;
        height: 50px;
        align-items: center;
        justify-content: flex-start;
        margin: 15px 15px 0;
`
);

const HeaderButton = experimentalStyled(IconButton)(
    () => `
        padding: 0;
        
        & svg {
            height: 25px;
            width: 25px;
        }
    `
)

const addMenuItemBadge = (
    items: MenuItems[],
    badgeValue: string
): MenuItems[] => {
  let itemsLocal = [...items];
  itemsLocal[1].items[0].badge = badgeValue;

  return itemsLocal;
}

function DrawerIndex() {
  const {account} = useAuth();
  const { drawerToggle, toggleDrawer } = useContext(DrawerContext);
  const [now] = useState<Date>(new Date());
  const [pendingBookingsCount, setPendingBookingsCount] = useState<number>(0);
  const closeDrawer = () => toggleDrawer();

  /*const getPendingBookingsCount = useCallback(async () => {

    try {
      const response = await sendGetRequest<{bookings: Booking[]}>(`bookings/by_structure/${account.structureId}`);

      if (response.bookings.length > 0) {
        const localBookings = response.bookings;

        let count = 0;

        for (let i = 0; i < localBookings.length; i++) {
          if (!isSameDay(now, new Date(localBookings[i].date))) {
            continue;
          }

          if (localBookings[i].status === BookingStatus.BOOKED) {
            count++;
          }
        }

        setPendingBookingsCount(count);
        return;
      }

      setPendingBookingsCount(0);

    } catch (err) {
      console.error(err);
    }
  }, [drawerToggle]);*/

  const getPendingBookingsCount = useCallback(async () => {
    try {
      const response = await sendGetRequest(`bookings/pending_count/${account.structureId}&${startOfDay(new Date())}`);

      // @ts-ignore
      if (response.count) {
        // @ts-ignore
        setPendingBookingsCount(response.count);
        // @ts-ignore
        console.log("count: ", response.count);
        return;
      }

      setPendingBookingsCount(0);
    } catch (e) {
      console.log(e);
    }
  }, [drawerToggle])

  useEffect(() => {
    getPendingBookingsCount();
  }, [drawerToggle]);

  const itemsWithBadge = addMenuItemBadge(menuItems, pendingBookingsCount.toString());

  return (
    <>
      <Hidden lgDown>
        <DrawerContainerWrapper>
          <Scrollbars autoHide>
            <TopSection>
              <Logo/>
            </TopSection>
            <DrawerMenu menuItems={itemsWithBadge} />
            <DrawerUserBox/>
          </Scrollbars>
        </DrawerContainerWrapper>
      </Hidden>
      <Hidden lgUp>
        <DrawerWrapper
          anchor="left"
          open={drawerToggle}
          onClose={closeDrawer}
          variant="temporary"
          elevation={9}
        >
          <DrawerContainerWrapper>
            <Scrollbars autoHide>
              <TopSection sx={{zIndex: 10, position: "sticky", top: 0, margin: 0, borderBottom: "1px solid #B4BEEA", background: "#ffffff"}}>
                <Box px={"15px"} display={"flex"} flexDirection={"row"} justifyContent={"flex-start"} alignItems={"center"} sx={{height: "100%", width: "100%"}}>
                <HeaderButton color="primary" onClick={closeDrawer}>
                  {<CloseIcon/>}
                </HeaderButton>
                  <Box display={"flex"} alignItems={"center"} justifyContent={"center"} sx={{width: "100%", pointerEvents: "none"}}>
                    <Box>
                      <LogoImg width={150}/>
                    </Box>
                  </Box>
                <HeaderButton disabled={true} color="primary" sx={{opacity: 0}}>
                  {<CloseIcon/>}
                </HeaderButton>
                </Box>
              </TopSection>
              <DrawerMenu menuItems={itemsWithBadge} />
              <DrawerUserBox/>
            </Scrollbars>
          </DrawerContainerWrapper>
        </DrawerWrapper>
      </Hidden>
    </>
  );
}

export default DrawerIndex;
